function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { TextPlaceholder } from "../../elements/TextPlaceholder";
import { Heading } from "../../typography/Heading";
import { Rating } from "../../elements/Rating";
import { Divider } from "../../elements/Divider";
import { Grid } from "../../layout/Grid";
import { GridRow } from "../../layout/GridRow";
import { GridColumn } from "../../layout/GridColumn";
import { Review } from "../../general-widgets/Review";
import { ACCEPT_PRIVACY_POLICY, ADD_A_REVIEW, COMMENTS, FORM_PROTECTION, GUEST_TYPE, MONTH, REVIEWS, REVIEWS_STAY_DATE_PREFIX, SUBMIT_REVIEW, TITLE, YEAR, YOUR_EMAIL, YOUR_LOCATION, YOUR_NAME, YOUR_REVIEW } from "../../../utils/default-strings/constants";
import { PLACEHOLDERS } from "./constants";
import { getModalFormMarkup } from "./utils/getModalFormMarkup";
import { transformReviewFactory } from "./utils/transformReviewFactory";
export var Component = function Component(_ref) {
  var id = _ref.id,
      headingText = _ref.headingText,
      isShowingPlaceholder = _ref.isShowingPlaceholder,
      ratingAverage = _ref.ratingAverage,
      reviews = _ref.reviews,
      reviewsStayDatePrefix = _ref.reviewsStayDatePrefix,
      props = _objectWithoutProperties(_ref, ["id", "headingText", "isShowingPlaceholder", "ratingAverage", "reviews", "reviewsStayDatePrefix"]);

  var reviewsToMap = isShowingPlaceholder && reviews.length === 0 ? PLACEHOLDERS : reviews;
  return React.createElement(Grid, {
    id: id
  }, React.createElement(GridRow, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, null, headingText))), React.createElement(GridRow, {
    verticalAlign: "middle"
  }, React.createElement(GridColumn, {
    computer: 6,
    floated: "left",
    mobile: 5,
    tablet: 5,
    textAlign: "left",
    verticalAlign: "middle"
  }, isShowingPlaceholder ? React.createElement(TextPlaceholder, {
    length: "medium"
  }) : React.createElement(Rating, {
    ratingNumber: ratingAverage
  })), React.createElement(GridColumn, {
    computer: 6,
    floated: "right",
    mobile: 7,
    tablet: 7,
    verticalAlign: "middle"
  }, getModalFormMarkup(props, isShowingPlaceholder))), reviewsToMap.map(transformReviewFactory({
    stayDatePrefix: reviewsStayDatePrefix
  })).map(function (review, index) {
    return React.createElement(GridRow, {
      key: buildKeyFromStrings(review.reviewText, index)
    }, React.createElement(GridColumn, {
      width: 12
    }, React.createElement(Review, _extends({
      isShowingPlaceholder: isShowingPlaceholder
    }, review)), React.createElement(Divider, null)));
  }));
};
Component.displayName = 'Reviews';
Component.defaultProps = {
  id: null,
  botProtectionMessage: FORM_PROTECTION,
  commentInputLabel: COMMENTS,
  emailInputLabel: YOUR_EMAIL,
  errorMessage: '',
  guestTypeInputLabel: GUEST_TYPE,
  guestTypeOptions: [],
  headingText: REVIEWS,
  isBotProtected: false,
  isPrivacyConsentRequired: false,
  isShowingPlaceholder: false,
  locationInputLabel: YOUR_LOCATION,
  monthInputLabel: MONTH,
  monthOptions: [],
  nameInputLabel: YOUR_NAME,
  onSubmit: Function.prototype,
  privacyConsentLabelLinkText: undefined,
  privacyConsentLabelLinkUrl: undefined,
  privacyConsentLabelText: ACCEPT_PRIVACY_POLICY,
  ratingInputLabel: YOUR_REVIEW,
  reviewFormHeading: ADD_A_REVIEW,
  reviews: [],
  reviewsStayDatePrefix: REVIEWS_STAY_DATE_PREFIX,
  submitButtonText: SUBMIT_REVIEW,
  successMessage: '',
  titleInputLabel: TITLE,
  validation: {},
  yearInputLabel: YEAR,
  yearOptions: []
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  botProtectionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  commentInputLabel: PropTypes.string,
  emailInputLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  guestTypeInputLabel: PropTypes.string,
  guestTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  headingText: PropTypes.string,
  id: PropTypes.string,
  isBotProtected: PropTypes.bool,
  isPrivacyConsentRequired: PropTypes.bool,
  isShowingPlaceholder: PropTypes.bool,
  locationInputLabel: PropTypes.string,
  monthInputLabel: PropTypes.string,
  monthOptions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  nameInputLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  privacyConsentLabelLinkText: PropTypes.string,
  privacyConsentLabelLinkUrl: PropTypes.string,
  privacyConsentLabelText: PropTypes.node,
  ratingAverage: PropTypes.number.isRequired,
  ratingInputLabel: PropTypes.string,
  reviewFormHeading: PropTypes.string,
  reviews: PropTypes.arrayOf(PropTypes.shape({
    ratingNumber: PropTypes.number.isRequired,
    reviewResponse: PropTypes.shape({
      dateTime: PropTypes.string.isRequired,
      source: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    }),
    reviewText: PropTypes.string.isRequired,
    reviewTitle: PropTypes.string.isRequired,
    reviewerCategory: PropTypes.string,
    reviewerLocation: PropTypes.string,
    reviewerName: PropTypes.string.isRequired,
    reviewerStayDate: PropTypes.string
  })),
  reviewsStayDatePrefix: PropTypes.string,
  submitButtonText: PropTypes.string,
  successMessage: PropTypes.string,
  titleInputLabel: PropTypes.string,
  validation: PropTypes.shape({
    comments: PropTypes.object,
    email: PropTypes.object,
    guestType: PropTypes.object,
    location: PropTypes.object,
    month: PropTypes.object,
    name: PropTypes.object,
    privacyConsent: PropTypes.object,
    rating: PropTypes.object,
    roomType: PropTypes.object,
    title: PropTypes.object,
    year: PropTypes.object
  }),
  yearInputLabel: PropTypes.string,
  yearOptions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  }))
} : {};